<script>
  import router from '../../lib/router';
  import { onMount } from 'svelte';
  import { derived, writable } from 'svelte/store';
  import APIClient from '../../state-charts/api-client';
  import { show_message } from '../../lib/flash.ts';
  import settings from '../../config';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import Table from './components/Table.svelte';
  import session from '../../lib/session';
  import Chips from './components/Chips.svelte';
  import StatusHeader from './components/StatusHeader.svelte';
  import { MDCTextField } from '@material/textfield';
  import Filter from './components/Filter.svelte';
  import CheckBox from '../../lib/components/CheckBox.svelte';
  import { format_float_time } from '../../lib/utils';

  // component options  ------------------------------------------------------ //

  export let route_name;
  export let query;

  // translated strings ------------------------------------------------------ //

  let search_text;
  let button_create;
  let hide_cancelled_label;
  let hide_cancelled = false;
  let first_load = false;

  // internal variables ------------------------------------------------------ //

  let reset = [{}];
  let show_filters = false;
  let filters = {
    start_date: null,
    initial_order_time: null,
    product_name: null,
    team_code: null,
    city_name: null,
    worker_email: null,
    order_by: null,
    order_ascending: false,
  };

  let is_same_timezone;
  let api_count = 0;
  let default_profile_image = `/uploads/profile_images/default-avatar.jpg`;
  let table_data = writable([]);
  let current_chip = 0;
  let current_chip_object;
  let current_group = ['order_status_initialized'];
  let per_page = 7;
  let current_page = 1;
  let number_of_pages;
  let role = 'orderer';
  let table_store = derived([table_data], ([$table_data]) => [$table_data]);
  let table_chips = [
    {
      name: null,
      value: 'type0',
      id: 'mdc-chip-10',
      group: ['order_status_initialized'],
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 6],
      enabled: true,
    },
    {
      name: null,
      value: 'type1',
      id: 'mdc-chip-11',
      group: ['order_status_in_progress'],
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 9],
      enabled: true,
    },
    {
      name: null,
      value: 'type2',
      id: 'mdc-chip-12',
      group: ['order_status_delivered'],
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 9, 14],
      enabled: true,
    },
    {
      name: null,
      value: 'type3',
      id: 'mdc-chip-13',
      group: [
        'order_status_cancelled_by_worker',
        'order_status_cancelled_by_orderer',
        'order_status_cancelled_by_admin',
        'order_status_not_approved',
        'order_status_completed',
      ],
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 8, 9],
      enabled: true,
    },
  ];
  let table_chips_worker = [
    {
      name: null,
      value: 'type0',
      id: 'mdc-chip-10',
      group: 'opportunities',
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 9, 11],
      enabled: true,
    },
    {
      name: null,
      value: 'type1',
      id: 'mdc-chip-11',
      group: ['order_status_in_progress'],
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 9],
      enabled: true,
    },
    {
      name: null,
      value: 'type2',
      id: 'mdc-chip-12',
      group: ['order_status_delivered'],
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 9],
      enabled: true,
    },
    {
      name: null,
      value: 'type3',
      id: 'mdc-chip-13',
      group: [
        'order_status_cancelled_by_worker',
        'order_status_cancelled_by_orderer',
        'order_status_cancelled_by_admin',
        'order_status_not_approved',
        'order_status_completed',
      ],
      icon: null,
      selected: null,
      showed_columns: [0, 1, 2, 3, 4, 5, 8, 9],
      enabled: true,
    },
  ];

  let searched = '';
  let labels = {
    filter: null,
    clear: null,
  };
  let headers = [
    { id: 'header-0', name: '', type: 'image', width: '70px', show: true },
    {
      id: 'header-1',
      name: null,
      type: 'string',
      width: '90px',
      show: true,
    },
    {
      id: 'header-2',
      name: null,
      type: 'string',
      width: '60px',
      show: true,
    },
    {
      id: 'header-3',
      name: null,
      type: 'string',
      width: '50px',
      show: true,
    },
    {
      id: 'header-4',
      name: null,
      type: 'price',
      width: '50px',
      show: true,
    },
    {
      id: 'header-5',
      name: null,
      type: 'string',
      width: '80px',
      show: true,
    },
    {
      id: 'header-6',
      name: null,
      type: 'string',
      width: '50px',
      show: true,
    },
    {
      id: 'header-7',
      name: null,
      type: 'string',
      width: '50px',
      show: false,
    },
    {
      id: 'header-8',
      name: null,
      type: 'rating',
      width: '50px',
      show: false,
    },
    {
      id: 'header-9',
      name: null,
      type: 'icon',
      width: '50px',
      show: false,
    },
    { id: 'header-10', name: 'id', type: 'string', width: '50px', show: false },
    {
      id: 'header-11',
      name: null,
      type: 'bool',
      width: '40px',
      show: false,
    },
    { id: 'header-12', name: '', type: 'bool', width: '40px', show: false },
    { id: 'header-13', name: '', type: 'string', width: '40px', show: false },
    {
      id: 'header-14',
      name: null,
      type: 'icon',
      width: '40px',
      show: false,
    },
  ];

  let show_back_button = false;
  let button_back_to_payment_and_reports = t9n(
    TS.BUTTON_BACK_TO_PAYMENT_AND_REPORTS
  );

  // utility functions -------------------------------------------------------- //

  const set_headers_for = chip => {
    headers.map((header, hdx) => {
      header.show = chip.showed_columns.includes(hdx);
    });
  };

  const select_chip_by_group = (chips, group) => {
    chips.map((chip, cdx) => {
      chip.selected = cdx === group;
      if (chip.selected) {
        current_chip = group;
        current_chip_object = chip;
        current_group = chip.group;
      }
    });
  };

  const select_chip_by_hexa = () => {
    let url_cancelled = query.cancelled;
    if (url_cancelled) {
      show_message(t9n(TS.ORDER_LIST_MESSAGE_CANCEL), 'success');
    }

    let url_completed = query.completed;
    if (url_completed) {
      show_message(t9n(TS.ORDER_LIST_MESSAGE_COMPLETE), 'success');
    }

    let url_applied = query.applied;
    if (url_applied) {
      show_message(t9n(TS.ORDER_LIST_MESSAGE_APPLY), 'success');
    }

    let url_approved = query.approved;
    if (url_approved === 'true') {
      show_message(t9n(TS.ORDER_LIST_MESSAGE_APPROVE), 'success');
    } else if (url_approved === 'false') {
      show_message(t9n(TS.ORDER_DETAILS_NOT_APPRV), 'success');
    }

    let page = query.page;
    if (!!page) {
      current_page = Number(page);
    }

    let group = 0;
    if (!!Number(query.group)) group = Number(query.group);

    select_chip_by_group(table_chips, group);
    set_headers_for(current_chip_object);
  };

  const select_filters = () => {
    let filter_query = query.filters;
    if (!!filter_query) {
      show_filters = true;
      filters.start_date = query.start_date;
      filters.initial_order_time = query.initial_order_time;
      filters.product_name = Number(query.product_name);
      filters.team_code = query.team_code;
      filters.city_name = query.city_name;
      filters.worker_email = query.worker_email;
      filters.order_by = query.order_by;
      filters.order_ascending = query.order_ascending;
    }
  };

  const get_merchant_currency = () => {
    return $session.merchant ? $session.merchant.currency_sign : '€';
  };

  const get_confirmed_time = confirmed => (confirmed !== null ? confirmed : '');

  const get_profile_image = (role, group, orderer_img, worker_img, status) => {
    if (is_status_cancelled(status) === false) {
      if (role === 'orderer') {
        if (group[0] === 'order_status_initialized') return orderer_img;
        if (group[0] === 'order_status_in_progress') return worker_img;
        if (group[0] === 'order_status_delivered') return worker_img;
        if (
          group[0] === 'order_status_cancelled_by_worker' ||
          group[0] === 'order_status_cancelled_by_orderer' ||
          group[0] === 'order_status_cancelled_by_admin' ||
          group[0] === 'order_status_not_approved' ||
          group[0] === 'order_status_completed'
        )
          return worker_img;
      } else {
        return orderer_img;
      }
    }

    return default_profile_image;
  };

  const is_status_cancelled = status => {
    if (
      status === 'order_status_cancelled_by_admin' ||
      status === 'order_status_cancelled_by_orderer' ||
      status === 'order_status_cancelled_by_worker'
    ) {
      return true;
    }
    return false;
  };

  const get_api_data_payment_icon = status => {
    if (!!status) {
      if (status === 'payment_status_payment_needed') {
        return 'error';
      } else {
        return 'done';
      }
    }
  };

  const get_api_data_icon = (rating, status) => {
    if (
      status === 'order_status_cancelled_by_admin' ||
      status === 'order_status_cancelled_by_orderer' ||
      status === 'order_status_cancelled_by_worker'
    ) {
      return null;
    } else {
      if (rating === 'sad') return 'sentiment_very_dissatisfied';
      if (rating === 'neutral') return 'sentiment_dissatisfied';
      if (rating === 'happy') return 'sentiment_satisfied_alt';
      if (rating === 'extremely_happy') return 'sentiment_very_satisfied';
      if (rating === null) return 'sentiment_dissatisfied';
    }
  };

  const get_api_data_product_category = id => {
    const language = $session.user.language ? $session.user.language : 'en';
    const products = $session.merchant.products;
    const product = products.find(p => p.product_id === id);

    return product.localized_names[`translation_${language}`];
  };

  const get_api_data_teams = teams => {
    return teams.map(t => t.name).join(', ');
  };

  const get_api_data_price = e => {
    let price;
    if ($session.user.last_role === 'orderer') {
      if (!!e.product.orderer_price) {
        price = e.product.orderer_price.toFixed(2);
      } else {
        price = 0;
      }
    } else {
      if (!!e.product.worker_price) {
        price = e.product.worker_price.toFixed(2);
      } else {
        price = 0;
      }
    }

    return `${(e.duration * price).toFixed(2)} ${get_merchant_currency()}`;
  };

  const get_api_data_time = e => {
    if (current_group !== 'history') {
      return e.initial_order_time;
    } else {
      return get_confirmed_time(e.confirmed_order_time);
    }
  };

  const get_api_data_location = e => {
    let usr_location = `${e.address.primary_address} ${e.address.city} ${e.address.postal_code}`;
    if ($session.user.last_role === 'worker') {
      if (e.status === 'order_status_initialized') {
        usr_location = `${e.address.city} ${e.address.postal_code}`;
      }
    }
    return usr_location;
  };

  const get_api_data_amount = e => {
    let amount;
    if (e.product.based_on === 'product_based_price') {
      if ($session.user.last_role === 'worker') {
        amount = '';
      } else {
        let currency = $session.merchant.currency_sign;
        amount = `${e.duration} ${currency}`;
      }
    } else {
      if (e.product.based_on === 'product_based_hours')
        amount = `${format_float_time(e.duration, true)}`;
      if (e.product.based_on === 'product_based_days')
        amount = `${e.duration} ${t9n(TS.LABEL_DAYS)}`;
      if (e.product.based_on === 'product_based_months')
        amount = `${e.duration} ${t9n(TS.LABEL_MONTHS)}`;
      if (e.product.based_on === 'product_based_units')
        amount = `${e.duration} ${t9n(TS.LABEL_UNITS)}`;
    }
    return amount;
  };

  const get_api_data_payment_status = e => {
    let payment_status = null;
    if (!!e.payment) {
      if (!!e.payment.payment_status) {
        payment_status = e.payment.payment_status;
      }
    }
    return payment_status;
  };

  const get_api_data_name = e => {
    let name;
    if (e.worker !== null) {
      name = `${e.worker.first_name} ${e.worker.last_name}`;
    } else {
      name = '';
    }
    return name;
  };

  const get_api_data_img = e => {
    let worker_img;
    if (e.worker !== null) {
      worker_img = e.worker.image_url;
    } else {
      worker_img = default_profile_image;
    }
    return (
      settings.api_host +
      get_profile_image(
        role,
        current_group,
        e.orderer.image_url,
        worker_img,
        e.status
      )
    );
  };

  const date_parse = val => {
    if (val < 10) return `0${val}`;
    return val;
  };

  window.get_data_from_api = async group => {
    api_count++;
    let current_orders = [];

    let tmp_group = current_group;
    if (!!group) tmp_group = group;

    let opportunities = false;
    if (tmp_group === 'opportunities') {
      tmp_group = [];
      opportunities = true;
    }

    let api_data = {
      page: current_page,
      number_of_items_per_page: per_page,
      role: role,
      statuses: tmp_group,
      filter_text: searched,
      only_opportunities: opportunities,
    };

    let start_date = new Date(filters.start_date);
    let tmp_date = `${start_date.getFullYear()}-${date_parse(
      start_date.getMonth() + 1
    )}-${date_parse(start_date.getDate())}`;

    if (!!filters.start_date)
      api_data.start_dates = [new Date(`${tmp_date}T00:00`).toISOString()];
    if (!!filters.initial_order_time)
      api_data.initial_order_time = filters.initial_order_time;
    if (!!filters.team_code) api_data.team_code = filters.team_code;
    if (!!filters.city_name) api_data.city_name = filters.city_name;
    if (!!filters.worker_email) api_data.worker_email = filters.worker_email;
    if (!!filters.order_by) api_data.order_by = filters.order_by;
    if (!!filters.order_ascending)
      api_data.order_ascending = filters.order_ascending;
    if (!!filters.product_name) api_data.product_ids = [filters.product_name];
    let data = await APIClient.get_orders(api_data);
    if (data) {
      number_of_pages = data.results_info.number_of_pages;

      data.orders.forEach(e => {
        let current_order;

        let payment_status = get_api_data_payment_status(e);
        current_order = {
          profile_img: {
            url: get_api_data_img(e),
            name: get_api_data_name(e),
          },
          task: {
            desc: e.description,
            based: get_api_data_product_category(e.product.product_id),
            teams: get_api_data_teams(e.teams),
            is_virtual: e.address.is_virtual,
          },

          init: get_api_data_time(e),
          amount: get_api_data_amount(e),
          price: get_api_data_price(e),
          location: get_api_data_location(e),
          apps: e.applicants,
          status: e.status,
          rating: {
            icon_top: get_api_data_icon(
              e.feedback.from_orderer.rating,
              e.status
            ),
            icon_bottom: get_api_data_icon(
              e.feedback.from_worker.rating,
              e.status
            ),
          },
          chat: {
            icon: 'chat',
            href: '#',
            worker: e.worker
          },
          id: e.order_uuid,
          is_applied: e.you_have_applied,
          no_payment: e.no_payment,
          unread_chat_messages: e.unread_chat_messages,
          payment: {
            payment_status: payment_status,
            icon: get_api_data_payment_icon(payment_status),
          },
        };
        current_orders.push(current_order);
      });

      table_data.set(current_orders);
    }
  };

  const get_order_table = async () => {
    select_chip_by_hexa();
    select_filters();
    await window.get_data_from_api();
  };

  const to_create = () => {
    // if (settings.env === 'production'){
    //   if(is_same_timezone){
    //     router.navigate('/order-new');
    //   } else{
    //     show_message(t9n(TS.DIFFERENT_TIMEZONE_ERROR), 'error');
    //   }
    // } else{
    router.navigate('/order-new');
    // }
  };

  const check_different_timezone = () => {
    let current_timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return current_timezone === $session.merchant.timezone;
  };

  const init_table = () => {
    role = $session.user.last_role;
    if (role === 'worker') table_chips = table_chips_worker;
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });
    let search = new MDCTextField(document.querySelector('.field_search'));
    get_order_table();
    first_load = true;
    is_same_timezone = check_different_timezone();
  };

  const toggle_filters = () => {
    if (role === 'orderer') {
      show_filters = !show_filters;
    } else {
      show_filters = false;
    }
  };

  const clear_filters = () => {
    filters = {
      start_date: null,
      initial_order_time: null,
      product_name: null,
      team_code: null,
      city_name: null,
      worker_email: null,
      order_by: null,
      order_ascending: null,
    };
    reset = [{}];
    window.history.pushState({}, null, 'orders');
  };

  const handle_hide_cancelled = () => {
    hide_cancelled = !hide_cancelled;
  };

  onMount(init_table);

  // reactive functions ------------------------------------------------------- //

  $: if (first_load && !!searched && searched !== '' && searched.length > 0) {
    (async () => {
      current_page = 1;
      await window.get_data_from_api();
    })();
  }

  $: if (filters && show_filters) {
    (async () => {
      await window.get_data_from_api();
    })();
  }

  $: if (query.workerearning) {
    show_back_button = true;
  }

  const translate_texts = () => {
    search_text = t9n(TS.TABLE_SEARCH_FIELD);
    button_create = t9n(TS.TABLE_BUTTON_CREATE);

    table_chips[0].name = t9n(TS.TABLE_CHIP_UNASSIGNED);
    table_chips[1].name = t9n(TS.TABLE_CHIP_IN_PROG);
    table_chips[2].name = t9n(TS.TABLE_CHIP_AW_APPR);
    table_chips[3].name = t9n(TS.TABLE_CHIP_HIST);

    table_chips_worker[0].name = t9n(TS.TABLE_CHIP_OPPS);
    table_chips_worker[1].name = t9n(TS.TABLE_CHIP_IN_PROG);
    table_chips_worker[2].name = t9n(TS.TABLE_CHIP_AW_APPR);
    table_chips_worker[3].name = t9n(TS.TABLE_CHIP_HIST);

    headers[1].name = t9n(TS.TABLE_HEADER_TASK);
    headers[2].name = t9n(TS.TABLE_HEADER_INIT_TIME);
    headers[3].name = t9n(TS.TABLE_HEADER_AMOUNT);
    headers[4].name = t9n(TS.TABLE_HEADER_PRICE);
    headers[5].name = t9n(TS.TABLE_HEADER_LOCATION);
    headers[6].name = t9n(TS.TABLE_HEADER_APPS);
    headers[7].name = t9n(TS.TABLE_HEADER_STATUS);
    headers[8].name = t9n(TS.TABLE_HEADER_RATING);
    headers[9].name = t9n(TS.TABLE_HEADER_CHAT);
    headers[11].name = t9n(TS.TABLE_HEADER_APPLY);
    headers[14].name = t9n(TS.TABLE_HEADER_STATUS);
    labels.filter = t9n(TS.TABLE_FILTERS_FILTER);
    labels.clear = t9n(TS.TABLE_FILTERS_CLEAR);
    hide_cancelled_label = t9n(TS.TABLE_HIDE_CANCELLED_LABEL);
  };

  $: if (!!$session) translate_texts();
</script>

<main class="wrapper fade-in">
  <!-- Search box -->
  <div class="search-box">

    <div class="mdc-text-field mdc-text-field--outlined field_search">
      <input
        style="margin-left: 13px;"
        id="table-search-field"
        class="mdc-text-field__input"
        bind:value={searched} />
      <div class="mdc-notched-outline">
        <div class="mdc-notched-outline__leading" />
        <div class="mdc-notched-outline__notch">
          <label class="mdc-floating-label" for="table-search-field">
            {search_text}
          </label>
        </div>
        <div class="mdc-notched-outline__trailing" />
      </div>
    </div>

    {#if role === 'orderer'}
      <div class="filter-buttons-desktop filter-btn" on:click={toggle_filters}>
        <i class="material-icons">filter_list</i>
        <p>{labels.filter}</p>
      </div>
    {/if}

    {#if show_filters}
      <div
        class="filter-buttons-desktop filter-btn"
        style="margin-left: 80px"
        on:click={clear_filters}>
        <i class="material-icons">clear</i>
        <p>{labels.clear}</p>
      </div>
    {/if}

    {#if role === 'orderer'}
      <button
        on:click={to_create}
        class="mdc-button mdc-button--oval mdc-button--raised">
        <span class="mdc-button__ripple" />
        <span>{button_create}</span>
      </button>
    {/if}
  </div>

  <!-- mobile version -->
  <div class="filter-buttons-mobile" on:click={toggle_filters}>
    {#if role === 'orderer'}
      <i class="material-icons">filter_list</i>
      <p>{labels.filter}</p>
    {/if}

    {#if show_filters && role === 'orderer'}
      <div style="margin-left: 10px; display: flex;" on:click={clear_filters}>
        <i class="material-icons">clear</i>
        <p>{labels.clear}</p>
      </div>
    {/if}
  </div>

  <Filter
    bind:filters
    {reset}
    show_filters={show_filters && role === 'orderer'} />

  <Chips
    bind:current_page
    bind:current_chip
    bind:current_group
    bind:headers
    bind:chips={table_chips} />

  <div style="display:flex;">
    <StatusHeader {current_chip} />
    {#if current_chip === 3}
      <div class="hide-cancelled">
        <CheckBox
          id="hide_cancelled"
          bind:value={hide_cancelled}
          label={hide_cancelled_label}
          on:change={handle_hide_cancelled} />
      </div>
    {/if}
  </div>

  <Table
    bind:headers
    table_data={$table_store}
    bind:table_chips
    bind:searched
    bind:per_page
    bind:current_page
    bind:number_of_pages
    user_role={role}
    bind:current_chip
    bind:current_group
    bind:hide_cancelled
    {filters}
    {show_filters} />

  {#if show_back_button}
    <div style="text-align: center">
      <a
        data-link={true}
        href={`/cards`}
        style="margin-bottom:10px; margin-top: 25px; padding-left: 8px;
        padding-right: 8px"
        data-mdc-dialog-initial-focus
        class="btn-close mdc-button mdc-button--unelevated">
        <span class="mdc-button__ripple" />
        {button_back_to_payment_and_reports}
      </a>
    </div>
  {/if}

</main>

<style type="text/scss">
  /* Reset Styles
    ********************************************************/

  .filter-btn {
    position: absolute;
    left: 560px;
    top: 14.5px;
    color: var(--button_background_color);
    cursor: pointer;
    display: flex;
  }

  .filter-btn:hover {
    opacity: 0.9;
  }

  .filter-btn p {
    font-size: 11pt;
    margin-left: 5px;
    margin-top: 4px;
  }

  .search-box {
    position: relative;
    display: flex;
    justify-content: space-between;
  }

  input {
    margin-left: 13px;
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-decoration: none;
  }

  html,
  body,
    /* main { display: flex; flex-direction: column; min-height: 100vh; } */
  main {
    display: flex;
    flex-direction: column;
    margin-top: 3rem !important;
    padding: 2rem 1rem;
    background: #fff;
    border-radius: 10px;
    box-shadow: var(--global-box-shadow);
  }

  section {
  }

  img {
    max-width: 100%;
  }

  input[type='number'] {
    text-align: center;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    opacity: 1;
  }

  /* Actual page elements
    ********************************************************/

  .hide-cancelled {
    margin-left: auto;
  }

  .field_search {
    width: 550px;
    margin-right: 0px;
  }

  .mdc-button--oval {
    border-radius: 40px;
    background-color: var(--mdc-theme-primary);
    color: white;
    height: 48px;
    padding-left: 15px;
    padding-right: 15px;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 1000px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }

    .filter-buttons-mobile {
      display: none;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }

    .filter-buttons-desktop {
      display: none;
    }

    .filter-buttons-mobile {
      margin-left: 17px;
      margin-top: 15px;
      display: flex;
      color: var(--button_background_color);
      cursor: pointer;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .filter-buttons-desktop {
      display: none;
    }

    .filter-buttons-mobile {
      margin-left: 17px;
      margin-top: 15px;
      display: flex;
      color: var(--button_background_color);
      cursor: pointer;
    }

    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    .mdc-button--oval {
      margin-left: 15px;
      width: 30%;
      height: 55px;
      padding: 10px;
      border-radius: 20px;
    }

    .field_search {
      width: 70%;
    }

    .mdc-button--oval span:nth-child(2) {
      overflow: hidden;
    }
  }
</style>
